import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from "axios";
import store from './store';
// ui以及主题样式
import Element from 'element-ui';
import './assets/css/globelcolor.scss';
import './assets/css/reset.scss';
import './assets/css/company.scss';
//font
import './assets/font/iconfont.css';
// 请求方法
import { getTokens } from '@/api/api.js';
import { seveCookie } from '@/utils/getToken.js';

//复制粘贴插件
import VueClipboard from 'vue-clipboard2';

// 使用bus进行通信
import VueBus from "vue-bus";

//
import Router from 'vue-router';

//图片截取插件
import VueCropper from 'vue-cropper';
//城市插件
import distpicker from 'v-distpicker';
import { seveCookieHttps } from './utils/getToken';
Vue.component('v-distpicker', distpicker);

Vue.prototype.$axios = axios

Vue.use(VueCropper);
Vue.use(Element);

Vue.use(VueBus);
Vue.use(VueClipboard);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

if(window.location.href.slice(8,13)=="zc360"){
  getTokens().then((res) => {
    //   console.log(res);
    //存储token
    // main.js?56d7:34 Uncaught (in promise) TypeError: Cannot read property 'token' of null
    if (res.status == 200) {
      if (res.data.status == 0) {
        seveCookieHttps('token', res.data.data.token);
      }
    } else {
      console.log(res.status, res.statusText);
      Toast('请刷新后重试');
    }
    new Vue({
      router,
      store,
      render: (h) => h(App),
      data() {
        return {};
      },
    }).$mount('#app');
  });
}else{
  getTokens().then((res) => {
    //   console.log(res);
    //存储token
    // main.js?56d7:34 Uncaught (in promise) TypeError: Cannot read property 'token' of null
    if (res.status == 200) {
      if (res.data.status == 0) {
        seveCookie('token', res.data.data.token);
      }
    } else {
      console.log(res.status, res.statusText);
      Toast('请刷新后重试');
    }
    new Vue({
      router,
      store,
      render: (h) => h(App),
      data() {
        return {};
      },
    }).$mount('#app');
  });
}



Vue.config.productionTip = false;
